import React, { useEffect, useRef, useState } from 'react';
import './Usermodule.css';
import axios from 'axios';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, } from 'primereact/confirmdialog';

import "primereact/resources/primereact.min.css";
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { Api } from '../../../services/api';
import { FaTrash } from 'react-icons/fa';
import { BiPlusMedical } from 'react-icons/bi';
import { InputNumber } from 'primereact/inputnumber';
import { InputTextarea } from 'primereact/inputtextarea';
import { useParams } from 'react-router-dom';

const RoleDetails = () => {

    const [isAdmin, setIsAdmin] = useState('Y');
    const [showAcess, setShowAcess] = useState('N');

    const [pmPoints, setPmPoints] = useState(0);
    const [vPPoints, setVPPoints] = useState(0);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [projectType, setProjectType] = useState([]);
    const [searchProjectType, setSearchProjectType] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const toast = useRef(null);
    const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] =
        useState(false);

  const { editId } = useParams();

    // -------------------------------------------------------------
    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);
    // -------------------------------------------------------------

    const formik = useFormik({
        initialValues: {
            title: '',
            max_pm_point: '',
            max_vp_point: '',
            role_id:'',
            id:''

        },

        validate: (data) => {
            let errors = {};



            return errors;
        },

        onSubmit: (data) => {

           
            var _body = {
                title: data.title,
                max_pm_point: data.performancePoints ?? 0,
                max_vp_point: data.vPPoints ?? 0,
                role_id: editId,
                id: data.id,
            }


            var url = Api.API_BASE_URL + 'role-performance-add';
           

            const token = localStorage.getItem('authToken');

            // Create headers with token if it exists
            const headers = {
                ...Api.headers,
                'Authorization': token ? `Bearer ${token}` : ''
            };

            fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(_body),
            })
                .then((response) => response.json())
                .then((Josn) => {
                    if (Josn.error != '') {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });

                    } else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
                        closeModal();
                        getProjectType();
                    }

                })
                .catch((error) => {
                    console.error("Error:", error);
                });


        }
    });
    // -------------------------------------------------------------
    const [ingredients, setIngredients] = useState([]);
    // -------------------------------------------------------------

    // _______________________________________________________

    const [type, setType] = useState('Add');
    const [title, setTitle] = useState('Add Project Type');
    const [projectTypeID, setProjectTypeID] = useState();
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [globalFilter, setGlobalFilter] = useState('');
    // const [globalFilter, setGlobalFilter] = useState(null);


    const openModal = () => {
        setProjectTypeID('');
        formik.resetForm();
        setType('Add');
        setTitle('Add Project Role');
        setIngredients([]);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setIsDeleteConfirmationModalOpen(false);
    };

    const editModal = (row) => {
        setProjectTypeID(row.id);
    
        formik.setFieldValue('id',row.id);
        formik.setFieldValue('title',row.title);
        formik.setFieldValue('performancePoints',parseInt(row.max_pm_point));
        formik.setFieldValue('vPPoints',parseInt(row.max_vp_point));
       
        
        setType('Edit');
        setTitle('Edit');
        setIsModalOpen(true);
    };



    useEffect(() => {
        getProjectType();
    }, []);


    const getProjectType = (project) => {
        const token = localStorage.getItem('authToken');

        if (!token) {
            console.error("No token found");
            return;
        }

        axios.get(Api.API_BASE_URL + 'role-performance-get/'+editId, {
            headers: {
                ...Api.headers,
                'Authorization': `Bearer ${token}`
            },
        })
            .then((response) => {
                var data = response.data.result;


                setProjectType(data);
                setSearchProjectType(data);
                setIsLoading(false);

            })
            .catch((error) => {
                console.error('Error fetching projects:', error);
                setIsLoading(false);
            });
    };


    const actionBodyTemplate = (rowData) => {
        console.log(rowData)
        var isDisabled = false;
        if (rowData.isAdmin == 'Y') {
            isDisabled = true;
        }
        return (
            <React.Fragment>

                <div onClick={(e) => e.stopPropagation()}>
                    <FaTrash onClick={isDisabled ? null : () => handleDeleteProject(rowData.id)} style={{ color: isDisabled ? 'lightgray' : 'darkred', pointerEvents: isDisabled ? 'none' : 'auto' }} />

                </div>

            </React.Fragment>
        );
    };

    // const handleDeleteProject = (projectId,) => {
    //     setProjectTypeID(projectId);
    //     setIsDeleteConfirmationModalOpen(true);
    // };

    const handleDeleteProject = (projectId) => {
        console.log('ddddddddddddddddddddddd',projectId);
        
        setProjectTypeID(projectId); // Update projectTypeID here
        setIsDeleteConfirmationModalOpen(true);
    };

    const confirmDelete = async () => {
        // Retrieve the token from localStorage
        const token = localStorage.getItem('authToken');


        // Check if token exists
        if (!token) {
            console.error('No token found in localStorage');
            return;
        }

        try {
           

            const response = await fetch(Api.API_BASE_URL + 'role-performance-delete/' + projectTypeID, {
                method: 'POST', // Specify the request method
                headers: {
                    'Authorization': `Bearer ${token}`, // Set the Authorization header
                    'Content-Type': 'application/json', // Set the Content-Type header
                },
                body: JSON.stringify({}) // Send an empty body if there is no payload (adjust if you have data to send)
            });

            if (!response.ok) {
                throw new Error('Failed to delete role performance');
            }


            const data = await response.json();

             toast.current.show({
            severity: 'info',
            summary: 'Confirmed',
            detail: data.result, // Assuming 'data.result' is the response's result message
            life: 3000
        });

        // Call getProjectType and closeModal after success
        getProjectType();
        closeModal();
        
        } catch (error) {
            console.error('Error fetching projects:', error);
        }
    };


    const searchrole = (searchValue) => {
        console.log('searchValue', searchValue);

        setProjectType([]);
        const searchResult = searchProjectType.filter((item) =>
            item.name.toLowerCase().includes(searchValue.toLowerCase())
        );
        setProjectType(searchResult);
        console.log(searchResult)
    }


    const header = (
        <div className="flex flex-wrap  align-items-center justify-content-between m-0 ">
            <span className="m-0 px-2 table-header">Manage Project Role</span>
            <div>
                <span className="p-input-icon-left ">
                    <InputText className="input-field m-1" type="search" onChange={(e) => searchrole(e.target.value)} placeholder="Search..." />
                </span>
                <button type="button" title='Add a new Project Role' style={{ cursor: 'pointer' }} onClick={openModal} className="custom-button m-2" >
                    <div className='flex gap-2 px-1 py-1' style={{ alignItems: 'center' }}>
                        <BiPlusMedical size={14} />
                        <span> ADD </span>
                    </div>
                </button>
            </div>
        </div>
    );



    const onRowSelect = (e) => {
        const rowData = e.data;
        editModal(rowData);
    };


    return (
        <>

            <div className="pagee-container mt-2">
                <Toast ref={toast} />
                <ConfirmDialog />
                <div className="pagination-datable-height">
                    {isLoading ? (
                        <div className="loading-spinner">
                            Loading...
                            <div className="spinner"></div>
                        </div>
                    ) : (
                        <DataTable
                            value={projectType}
                            paginator rows={14}
                            dataKey="_id"
                            selection={selectedProduct}
                            onRowSelect={(e) => onRowSelect(e)}
                            onSelectionChange={(e) => setSelectedProduct(e.value)}
                            tableStyle={{ minWidth: '50rem' }} selectionMode="single" header={header} globalFilter={globalFilter} >

                            <Column body={actionBodyTemplate} header="Action" style={{ textAlign: 'center', width: '100px' }} exportable={false}></Column>
                            <Column field="title" header="Performance Bonus Measurables Review" ></Column>

                            <Column field="max_pm_point" header="Performance Points" ></Column>

                            <Column field="max_vp_point" header="VP POINTS" ></Column>

                            {/* <Column field="status" header="Status" style={{ textAlign: 'center' }} body={(e) => showColor(e.status)}></Column> */}
                        </DataTable>
                    )}
                </div>
            </div>

            {/* ---------------------------------------------------------------*/}
            <Dialog header="" bodyClassName="dialog-body" visible={isModalOpen} maximizable style={{ width: '40vw' }} dismissableMask="true" onHide={() => { setIsModalOpen(false); setSelectedProduct(null); }}>
                <div className='p-4 overflow-hidden '>
                    <form onSubmit={formik.handleSubmit} className="" >
                        <div className="formgrid grid">

                            <div className="col-6 flex-col">
                                <h4 className='card-heading'>Title</h4>
                                <div className='pt-2'>
                                    <InputTextarea
                                        id="title"
                                        name="title"
                                        autoResize
                                        value={formik.values.title}
                                        onChange={(e) => {
                                            console.log(e.target.value);
                                            formik.setFieldValue('title', e.target.value);
                                        }}
                                        className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('title') })}
                                        style={{
                                            width: '100%',
                                            height: '40px',
                                            boxSizing: 'border-box',
                                            border: '2px solid #DCE4C9',
                                            borderRadius: '0px',
                                            fontSize: '14px',
                                            textAlign: 'center',
                                            marginTop: '0px'
                                        }}
                                    />

                                </div>

                            </div>

                            <div className="col-3">
                                <h4 className='card-heading'>Performance Points</h4>
                                <div className='pt-2'>
                                    <input type='number' id="performancePoints" name="performancePoints"
                                        // value={pmPoints} 
                                        // onChange={(e) => setPmPoints(e.target.value)} 
                                        value={formik.values.performancePoints}
                                        onChange={formik.handleChange}
                                        className={classNames('p-2')}
                                        style={{
                                            width: '100%',
                                            height: '40px',
                                            boxSizing: 'border-box',
                                            border: '2px solid #DCE4C9',
                                            borderRadius: '0px',
                                            fontSize: '14px',
                                            textAlign: 'center',
                                            marginTop: '0px'
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-3">
                                <h4 className='card-heading'>VP POINTS</h4>
                                <div className='pt-2'>
                                    <input type='number' id="vPPoints" name="vPPoints"
                                        // value={vPPoints} 
                                        // onChange={(e) => setVPPoints(e.target.value)} 
                                        value={formik.values.vPPoints}
                                        onChange={formik.handleChange}
                                        className={classNames('p-2')}
                                        style={{
                                            width: '100%',
                                            height: '40px',
                                            boxSizing: 'border-box',
                                            border: '2px solid #DCE4C9',
                                            borderRadius: '0px',
                                            fontSize: '14px',
                                            textAlign: 'center',
                                            marginTop: '0px'
                                        }}
                                    />
                                </div>
                            </div>

                        </div>
                        <div className="flex flex-wrap justify-content-center mt-5">
                            <Button label="Submit" type="submit" className='p-2 customSave-button' />
                        </div>
                    </form>

                </div>
            </Dialog>


            {/* //*------------------ DeleteConfirmation --------------------------*/}
            {isDeleteConfirmationModalOpen && (
                <div className="modal">
                    <div className="small-modal-content">
                        <div className="modal-headerx">
                            <h5 className="modal-title">Delete Confirmation</h5>
                            <button className="modal-closex" onClick={closeModal}>
                                &times;
                            </button>
                        </div>
                        <div className="modal-bodyx">
                            <p>"Are you sure you want to delete this? "</p>
                        </div>
                        <div className="modal-footer-cancelx">
                            <button className="cancel-buttonx" onClick={closeModal}>
                                Cancel
                            </button>
                            <button className="delete-buttonx" onClick={confirmDelete}>
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {/* //!------------------ DeleteConfirmation --------------------------*/}

        </>
    )
}

export default RoleDetails